import React, { useState } from 'react';
import { Layout } from 'antd';
import MainContent from './components/MainContent';

const { Content } = Layout;

const AnalysePage: React.FC = () => (
    <Layout style={{ height: '100vh', background: '#fff' }}>
      <Content>
        <MainContent />
      </Content>
    </Layout>
);

export default AnalysePage;
